export default function ShippingLine({
  title,
  price,
  children,
}: {
  title: string;
  price?: string;
  children?: React.ReactNode;
}) {
  return (
    <div className="flex w-full items-center justify-between gap-4">
      <div className="flex flex-col gap-1">
        <span id={`shipping-line-${title}-label`} className="text-on-surface">
          {title}
        </span>
        {price && (
          <span className="body-md text-on-surface-variant">{price}</span>
        )}
      </div>
      {children && <span className="body-md font-medium">{children}</span>}
    </div>
  );
}
